import { useState } from "react";
import { EventType } from "@/hooks/client/useClientPortalPaymentPlansMixpanelEvents";
import SlideBottomDialog from "../../modals/slideBottomDialog";
import { CherryLogo } from "../cherryLogo";
import PaymentPlanSliderCard, {
  PaymentPlanCardBaseProps,
} from "./paymentPlanSliderCard";

export default function CherryPromotionCard({
  cherryApplicationLink,
  ...props
}: {
  cherryApplicationLink: string;
} & PaymentPlanCardBaseProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <PaymentPlanSliderCard
        cardProps={{
          title: <CherryLogo />,
          description:
            "Zero obligation application. Apply in seconds, enjoy your services now, and pay over time with monthly payments and zero-interest options.",
        }}
        buttonProps={{
          copy: "Check eligibility",
          onClick: () => setIsDialogOpen(true),
        }}
        actionProps={{
          eventType: EventType.CHERRY_CHECK_ELIGIBILITY_CLICKED,
          ...props,
        }}
      />
      <SlideBottomDialog
        fullWidth
        title="Cherry"
        withActions={false}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        PaperProps={{
          sx: {
            height: "100vh",
            "> .MuiDialogContent-root": {
              overflow: "hidden",
            },
          },
        }}
      >
        <iframe
          src={cherryApplicationLink}
          title="Cherry Application Form"
          sandbox="allow-scripts allow-forms allow-same-origin"
          style={{
            border: 0,
            width: "100%",
            height: "100%",
          }}
        />
      </SlideBottomDialog>
    </>
  );
}
